export const NOW_DATE = new Date()
export const MIN_ADULT_AGE = 18
export const MIN_MONTH = 3
export const DEFAULT_MAX_AGE = 70
export const DEFAULT_START_DATE = new Date(1991, 0, 1)
